import React from 'react'

const SkillPill = ({ label }) => {
    return (
        <div
            className="rounded-[29px] cursor-pointer font-liberation transition-all duration-500 cursor-pointer text-[16px] xs:text-[14px] leading-[18px] text-center px-[32px] py-[14px] xs:px-[26px] xs:py-[12px]  bg-[#E8F2F6] hover:bg-[#EB532E] text-secondary hover:text-[#fff]"
        >
            {label}
        </div>
    )
}

export default SkillPill